export default __webpack_public_path__ + "static/media/graduation.cab694f2.jpeg";